// extracted by mini-css-extract-plugin
module.exports = {"Language":"Language_Language__1hqpG","link":"Language_link__1rfJL","active":"Language_active__TT0cC"};